module.exports = __webpack_public_path__ + "media/images/grass-41ad0d97242e7b886a8349c233a9b43f.png";